export const GAME_VERSION = "v1.0.9";

// Set to true to enable F1 2026 Grand Prix mode:
//   - Race dates are shown on each track card
//   - Tracks are ordered by the 2026 F1 calendar
//   - Tracks whose race weekend hasn't started yet are disabled
//   - Random only picks from currently-enabled tracks
//   - The active race weekend gets a "NOW" ribbon
// Set to false for freeplay mode (all tracks enabled, ordered A-Z by country)
export const GP_MODE = true;

export const TRACK_NAMES = [
  "albertpark", // R1  Mar 6-8
  "shanghai", // R2  Mar 13-15
  "suzuka", // R3  Mar 27-29
  "bahrain", // R4  Apr 10-12
  "montreal", // R7  May 22-24
  "monaco", // R8  Jun 5-7
  "catalunya", // R9  Jun 12-14
  "spielberg", // R10 Jun 26-28
  "silverstone", // R11 Jul 3-5
  "spa", // R12 Jul 17-19
  "budapest", // R13 Jul 24-26
  "monza", // R15 Sep 4-6
  "baku", // R17 Sep 24-26
  "marinabay", // R18 Oct 9-11
  "americas", // R19 Oct 23-25
  "mexico", // R20 Oct 30-Nov 1
  "interlagos", // R21 Nov 6-8
  "abudhabi", // R24 Dec 4-6
  "hockenheim", // no 2026 race
  "paulricard", // no 2026 race
  "sochi", // no 2026 race
];

export const TRACK_RACE_DATES = {
  albertpark: "Mar 6–8",
  shanghai: "Mar 13–15",
  suzuka: "Mar 27–29",
  bahrain: "Apr 10–12",
  montreal: "May 22–24",
  monaco: "Jun 5–7",
  catalunya: "Jun 12–14",
  spielberg: "Jun 26–28",
  silverstone: "Jul 3–5",
  spa: "Jul 17–19",
  budapest: "Jul 24–26",
  monza: "Sep 4–6",
  baku: "Sep 24–26",
  marinabay: "Oct 9–11",
  americas: "Oct 23–25",
  mexico: "Oct 30–Nov 1",
  interlagos: "Nov 6–8",
  abudhabi: "Dec 4–6",
  hockenheim: null,
  paulricard: null,
  sochi: null,
};

// Race weekend start/end dates as [month, day] for the 2026 season
export const TRACK_RACE_DATE_RANGES = {
  albertpark: { start: [3, 6], end: [3, 8] },
  shanghai: { start: [3, 13], end: [3, 15] },
  suzuka: { start: [3, 27], end: [3, 29] },
  bahrain: { start: [4, 10], end: [4, 12] },
  montreal: { start: [5, 22], end: [5, 24] },
  monaco: { start: [6, 5], end: [6, 7] },
  catalunya: { start: [6, 12], end: [6, 14] },
  spielberg: { start: [6, 26], end: [6, 28] },
  silverstone: { start: [7, 3], end: [7, 5] },
  spa: { start: [7, 17], end: [7, 19] },
  budapest: { start: [7, 24], end: [7, 26] },
  monza: { start: [9, 4], end: [9, 6] },
  baku: { start: [9, 24], end: [9, 26] },
  marinabay: { start: [10, 9], end: [10, 11] },
  americas: { start: [10, 23], end: [10, 25] },
  mexico: { start: [10, 30], end: [11, 1] },
  interlagos: { start: [11, 6], end: [11, 8] },
  abudhabi: { start: [12, 4], end: [12, 6] },
  hockenheim: null,
  paulricard: null,
  sochi: null,
};

export const TRACK_DISPLAY_NAMES = {
  abudhabi: "Yas Marina Circuit, United Arab Emirates",
  albertpark: "Albert Park Circuit, Australia",
  americas: "Circuit of the Americas, United States",
  bahrain: "Bahrain International Circuit, Bahrain",
  baku: "Baku City Circuit, Azerbaijan",
  budapest: "Hungaroring, Hungary",
  catalunya: "Circuit de Barcelona-Catalunya, Spain",
  hockenheim: "Hockenheimring, Germany",
  interlagos: "Autódromo José Carlos Pace, Brazil",
  marinabay: "Marina Bay Street Circuit, Singapore",
  mexico: "Autódromo Hermanos Rodríguez, Mexico",
  monaco: "Circuit de Monaco, Monaco",
  montreal: "Circuit Gilles Villeneuve, Canada",
  monza: "Autodromo Nazionale di Monza, Italy",
  paulricard: "Circuit Paul Ricard, France",
  shanghai: "Shanghai International Circuit, China",
  silverstone: "Silverstone Circuit, United Kingdom",
  sochi: "Sochi Autodrom, Russia",
  spa: "Circuit de Spa-Francorchamps, Belgium",
  spielberg: "Red Bull Ring, Austria",
  suzuka: "Suzuka Racing Course, Japan",
};

export const TEAMS = [
  {
    name: "MacLairen Motors",
    primary: "#FF6E0A", // vivid papaya orange (McLaren-like, slightly warmer)
    secondary: "#1A1A1A", // deep graphite
    accent: "#00B5FF", // light cyan streak accent
  },
  {
    name: "Astern Martian",
    primary: "#115C3C", // deep emerald (Aston-ish but darker)
    secondary: "#C0B283", // metallic champagne trim
    accent: "#25E89B", // neon mint accent
  },
  {
    name: "Alphine Peaks",
    primary: "#1A3DE0", // bright alpine blue
    secondary: "#E2E2E2", // silver-gray
    accent: "#FF1E3C", // tricolor red accent
  },
  {
    name: "Alpha Omego Racing",
    primary: "#9A0019", // burgundy wine
    secondary: "#EDEDED", // near-white
    accent: "#1F6FFF", // small blue stripe accent
  },
  {
    name: "Hazz Autosport",
    primary: "#BFBFBF", // light gray base
    secondary: "#212121", // matte black trim
    accent: "#E43131", // red accent stripe
  },
  {
    name: "Red Ox Velocity",
    primary: "#2E2B87", // navy indigo base
    secondary: "#F3D000", // gold-yellow bull pattern (less saturated)
    accent: "#E42C2C", // red logo accent
  },
  {
    name: "Scuderia Albatross",
    primary: "#2E89A0", // turquoise blue (AlphaTauri-ish)
    secondary: "#ECECEC", // off-white
    accent: "#1E1E1E", // charcoal details
  },
  {
    name: "Willpower Racing",
    primary: "#2244FF", // rich royal blue (Williams-like)
    secondary: "#F0F0F0", // white chassis
    accent: "#FF2C9F", // magenta accent line
  },
  {
    name: "Scuderia Fajita",
    primary: "#D82020", // spicy red
    secondary: "#F3E2C0", // tortilla tan secondary
    accent: "#222222", // black trim
  },
  {
    name: "Mercury-AMG Photon",
    primary: "#C0C0C0", // metallic silver
    secondary: "#111111", // carbon black
    accent: "#05FFD5", // bright teal (Merc AMG greenish glow)
  },
];
